<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<el-form ref="form" :model="form" label-width="80px" size="mini">
					<el-form-item label="对象类型" required>
						<el-select v-model="form.objecttype" @change="objecttypeChange">
							<el-option label="部门" value="部门"></el-option>
							<el-option label="供应商" value="供应商"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="预算对象" required>
						<el-select v-model="form.objectid" filterable>
							<el-option v-for="(item,index) in object" :key="index" :label="item.name" :value="item.id" ></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="事项" required>
						<emun name="budgetmatter" :emptyoption="false" v-model="form.matter">
						</emun>
					</el-form-item>
					<el-form-item label="预算金额" required>
						<el-input-number v-model="form.budgetamount" :precision="4" controls-position="right"
							size="mini"></el-input-number>
					</el-form-item>
					<el-form-item label="凭证">
						<upload :formCreateInject="true" ref="budgetdistributionupload"  />
					</el-form-item>
					<el-form-item label="备注">
						<el-input v-model="form.mark" ></el-input>
					</el-form-item>
				</el-form>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确定" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import upload from '@_system/components/formcomponents/common/upload/index.vue'
	import emun from '@_system/components/formcomponents/common/select/emun/select.vue'
	export default {
		mixins: [modalMixins],
		props: {
			currentrow: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				suppliername: null,
				modal_title: '新增预算分配',
				modal_width: 600,
				modal_height: 500,
				list_footerField: [{
					field: 'needamount',
					toFixed: 2
				}],
				object:[],
				form: {
					objectid: null,
					objecttype: null,
					matter: null,
					budgetamount: 0,
					mark:null
				}
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			objecttypeChange(e){
				if(e=='供应商'){
					this.object = window.systemData.supplier.map((item)=>{
						return {name:item.name,id:item.id}
					})
				}
				if(e=='部门'){
					let leafdepartment = []
					window.systemData.department.forEach((item)=>{
						let isleaf = true
						window.systemData.department.forEach((_item)=>{
							if(_item.parentid == item.id){
								isleaf = false
							}
						})
						if(isleaf){
							leafdepartment.push({name:item.name,id:item.id})
						}
					})

					this.object = leafdepartment
				}
				this.form.objectid = null
			},
			initform() {
				this.form = {
					objectid: null,
					objecttype: null,
					matter: null,
					budgetamount: 0,
					mark:null
				}
			},
			modal_init() {
				this.initform()
				this.suppliername = this.currentrow ? this.currentrow.name : null
			},
			submit() {
				this.loading = true
				this.form.budgetid = this.currentrow.id
				this.form.file_img = this.$refs.budgetdistributionupload.value
				if (!this.form.objectid || !this.form.objecttype || !this.form.matter) {
					this.$message.error('缺少必填项')
					return
				}

				this.$api.budget.adddistribution(this.form).then(() => {
					this.loading = false
					this.$emit('success')
					this.modal_cancel()
					this.$message.success('操作成功')
				}, () => {
					this.loading = false
				})
				//this.init()
			},
			reset() {
				//this.init()
			},
			supplierdeductChange(e) {
				if (e) {
					let deducttype = e[e.length - 1]
					this.$api.emunextend_supplierdeduct.get(deducttype).then((res) => {
						if (res) {
							this.form.deductscore = res.score
						}
					})
				}
				console.log(window.systemData)
			}
		},
		components: {
			upload,
			emun
		}
	}
</script>